import { useTranslation } from "react-i18next";
import React from "react";
import StudentReport from "../components/StudentReport";
import { useStudentMarks } from "../hooks/useStudentMarks";
import { Spin, Alert, Card } from "antd";
import { useSelector } from "react-redux";
import StudentSelectorWrapper from "../../../../components/Peoples/guardian/StudentSelectorWrapper";
import { useEffectiveStudentId } from "../../../../components/Peoples/guardian/hooks/useEffectiveStudentId";
import PageHeader from "components/Common/PageHeader";

const StudentMarks: React.FC = () => {
  const { t } = useTranslation();
  const user = useSelector((state: any) => state.authSlice.user);
  const studentId = useEffectiveStudentId();

  const { marksData, isLoading, error } = useStudentMarks(studentId);
  const breadcrumbItems = [
    { label: "dashboard", path: "/dashboard" },
    { label: "my_marks", active: true }
  ];
  return (

    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={t("my_marks")}
          breadcrumbItems={breadcrumbItems}
        />

        <div >
          <div >
            <StudentSelectorWrapper>
              {studentId ? (
                <>
                  {isLoading ? (
                    <div className="d-flex justify-content-center my-5">
                      <Spin size="large" />
                    </div>
                  ) : error ? (
                    <Alert message={t("error_fetching_marks")} type="error" showIcon className="mb-3" />
                  ) : (
                    <div>
                      {marksData ? (
                        <StudentReport marksData={marksData} />
                      ) : (
                        <Alert message={t("no_marks_available")} type="warning" showIcon />
                      )}
                    </div>
                  )}
                </>
              ) : (
                <p className="text-danger">{t("select_student_first")}</p>
              )}
            </StudentSelectorWrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentMarks;
